import { render, staticRenderFns } from "./CardsStatistic.vue?vue&type=template&id=4962c07f&scoped=true&"
import script from "./CardsStatistic.vue?vue&type=script&lang=js&"
export * from "./CardsStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4962c07f",
  null
  
)

export default component.exports